export default "__VITE_ASSET__B4b$_rU1__"